// eslint-disable-next-line import/no-anonymous-default-export
export default `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10" cy="10" r="10" fill="black"/>
<rect x="5" y="9.78262" width="10" height="3.91304" fill="url(#paint0_linear_11555_1387)"/>
<rect x="5" y="7.17392" width="10" height="1.95652" fill="url(#paint1_linear_11555_1387)"/>
<rect x="5" y="5.43478" width="10" height="1.08696" fill="url(#paint2_linear_11555_1387)"/>
<defs>
<linearGradient id="paint0_linear_11555_1387" x1="5.32609" y1="11.7391" x2="15" y2="11.7391" gradientUnits="userSpaceOnUse">
<stop offset="0.395" stop-color="#FFDE5B"/>
<stop offset="0.835" stop-color="#EDAD4C"/>
<stop offset="1" stop-color="#EFAE4C"/>
</linearGradient>
<linearGradient id="paint1_linear_11555_1387" x1="5.32609" y1="8.15218" x2="15" y2="8.15218" gradientUnits="userSpaceOnUse">
<stop offset="0.395" stop-color="#FFDE5B"/>
<stop offset="0.835" stop-color="#EDAD4C"/>
<stop offset="1" stop-color="#EFAE4C"/>
</linearGradient>
<linearGradient id="paint2_linear_11555_1387" x1="5.32609" y1="5.97826" x2="15" y2="5.97826" gradientUnits="userSpaceOnUse">
<stop offset="0.395" stop-color="#FFDE5B"/>
<stop offset="0.835" stop-color="#EDAD4C"/>
<stop offset="1" stop-color="#EFAE4C"/>
</linearGradient>
</defs>
</svg>`;
